import FormsService from "@/services/FormsService"

export default {
  namespaced: true,
  state: {
    forms: [],
    pagination: {
      total: null,
      perPage: 50,
      page: 1
    }
  },
  getters: {
    forms: state => state.forms
  },
  actions: {
    async getForms ({ commit }, params, loader = true) {
      try {
        loader && window.loader.show()
        const { data } = await FormsService.index({})
        commit('UPDATE_FORMS', data)
      } finally {
        loader && window.loader.hide()
      }
    },
    async getFormById ({}, id, loader = true) {
      try {
        loader && window.loader.show()
        const { data } = await FormsService.show(id)
        return data
      } finally {
        loader && window.loader.hide()
      }
    },
    async saveForm ({}, payload, loader = true) {
      try {
        loader && window.loader.show()
        const { data } = await FormsService.store(payload)
        return data
      } finally {
        loader && window.loader.hide()
      }
    }
  },
  mutations: {
    UPDATE_FORMS (state, data) {
      state.forms = data
    }
  }
}
